// extracted by mini-css-extract-plugin
export default {"button":"submitOrderButton-module__button__c9+wD","loader":"submitOrderButton-module__loader__Msr1A"};